var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72656 15.7156L1.25781 14.2906C1.78281 14.1156 2.20469 13.8094 2.52344 13.3719C2.84219 12.9344 3.00156 12.4406 3.00156 11.8906V4.05312C2.70156 3.72812 2.42969 3.37813 2.18594 3.00313C1.94219 2.62813 1.73281 2.22812 1.55781 1.80313L2.94531 1.20312C3.47031 2.42813 4.27969 3.40937 5.37344 4.14687C6.46719 4.88437 7.67656 5.25313 9.00156 5.25313C10.3266 5.25313 11.5359 4.88437 12.6297 4.14687C13.7234 3.40937 14.5328 2.42813 15.0578 1.20312L16.4453 1.80313C16.2703 2.22812 16.0578 2.62813 15.8078 3.00313C15.5578 3.37813 15.2891 3.72812 15.0016 4.05312V11.8906C15.0016 12.4406 15.1578 12.9344 15.4703 13.3719C15.7828 13.8094 16.2016 14.1156 16.7266 14.2906L16.2578 15.7156C15.4328 15.4406 14.7672 14.9531 14.2609 14.2531C13.7547 13.5531 13.5016 12.7656 13.5016 11.8906V5.36563C12.8391 5.80313 12.1297 6.14375 11.3734 6.3875C10.6172 6.63125 9.82656 6.75313 9.00156 6.75313C8.17656 6.75313 7.38281 6.63125 6.62031 6.3875C5.85781 6.14375 5.15156 5.80313 4.50156 5.36563V11.8906C4.50156 12.7656 4.24531 13.5531 3.73281 14.2531C3.22031 14.9531 2.55156 15.4406 1.72656 15.7156Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNeck);
export default __webpack_public_path__ + "static/media/icon-neck.7b1877c9721fb4ee89492f859db334ef.svg";
export { ForwardRef as ReactComponent };